import { IconPlusCircle } from 'featherico';
import { isEqual } from 'lodash/fp';
import { useForm, useFormState } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import Button from '../../../../components/Button';
import CheckboxContainer from '../../../../components/CheckboxContainer';
import { isFeatureEnabled } from '../../../../services/Features';
import ConfigWithCaption from './ConfigWithCaption';
import CustomFieldMapping from './CustomFieldMapping';
import { CUSTOM_FIELD, CUSTOM_FIELD_OVERWRITE_EMPTY } from './constants';
import { CustomMapping, mkCustomMapping } from './customMapping';
import { CustomFieldConfig } from './types';

interface Props {
    name: string;
    config: CustomFieldConfig;
}

export default function CustomMappingSection({ name, config }: Props) {
    const { values } = useFormState();
    const { mutators } = useForm();

    if (!isFeatureEnabled('FEATURE_userImportCustomFields')) {
        return null;
    }

    return (
        <div>
            <h5>Custom Fields</h5>

            {isFeatureEnabled('FEATURE_userImportCustomFieldsKeepOriginalOption') && (
                <CheckboxContainer>
                    <ConfigWithCaption
                        name="customMappingKeepOriginalValueIfEmpty"
                        caption={CUSTOM_FIELD_OVERWRITE_EMPTY.caption()}
                        label={CUSTOM_FIELD_OVERWRITE_EMPTY.label}
                        isDisabled={false}
                    />
                </CheckboxContainer>
            )}

            <FieldArray<CustomMapping> name="customMappings" isEqual={isEqual}>
                {({ fields }) => {
                    const deleteRow = (i: number) => (fields.length && fields.length > 1 ? fields.remove(i) : null);
                    return (
                        <>
                            {fields.map((field, index) => (
                                <CustomFieldMapping
                                    key={field}
                                    caption={CUSTOM_FIELD.caption(name)}
                                    sourceLabel={CUSTOM_FIELD.sourceLabel(name)}
                                    targetLabel={CUSTOM_FIELD.targetLabel}
                                    config={config}
                                    field={field}
                                    onDelete={() => deleteRow(index)}
                                    nrFields={fields.length || 0}
                                    customMappingState={values.customMappings[index]}
                                />
                            ))}
                        </>
                    );
                }}
            </FieldArray>

            <section style={{ marginBottom: '30px' }}>
                <div>
                    <Button kind="LINK" onClick={() => mutators.push('customMappings', mkCustomMapping())}>
                        <IconPlusCircle /> Customize another field
                    </Button>
                </div>
            </section>
        </div>
    );
}
